import React from "react";
import { T } from "../context/LanguageContext";

const statusBadge = (e) => {
  if (e.status === "live" || e.status === "in progress")
    return <span className="inline-flex items-center gap-1 rounded bg-red-500 px-1.5 py-0.5 text-[10px] font-extrabold uppercase text-white"><span className="live-pulse h-1.5 w-1.5 rounded-full bg-white" />Live</span>;
  if (e.status === "final")
    return <span className="rounded bg-slate-200 px-1.5 py-0.5 text-[10px] font-extrabold uppercase text-slate-600">Final</span>;
  return <span className="rounded bg-blue-100 px-1.5 py-0.5 text-[10px] font-extrabold uppercase text-[#0055FF]">Upcoming</span>;
};

export const EventList = ({ events }) => {
  if (!events?.length)
    return <p className="py-4 text-sm text-slate-500" data-testid="no-related-events"><T>No related events in the current demo dataset.</T></p>;
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2" data-testid="related-events">
      {events.map((e) => (
        <div key={e.id} data-testid={`related-event-${e.id}`} className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
          <div className="flex items-center justify-between text-[11px] font-semibold text-slate-500">
            <span className="flex items-center gap-1.5">{statusBadge(e)} {e.sport}</span>
            <span className="font-mono-score">{e.clock}</span>
          </div>
          <div className="mt-3 space-y-2">
            <div className="flex items-center justify-between">
              <span className="flex items-center gap-2 text-sm font-semibold text-slate-800">{e.home.flag} {e.home.name}</span>
              <span className="font-mono-score text-sm font-bold">{e.home.score}</span>
            </div>
            {e.away.name && (
              <div className="flex items-center justify-between">
                <span className="flex items-center gap-2 text-sm font-semibold text-slate-800">{e.away.flag} {e.away.name}</span>
                <span className="font-mono-score text-sm font-bold">{e.away.score}</span>
              </div>
            )}
          </div>
          <p className="mt-3 border-t border-slate-100 pt-2 text-[11px] text-slate-400">{e.competition} · {e.venue}</p>
        </div>
      ))}
    </div>
  );
};
